<template>
  <div>
    <div style="margin-top: 40px;"></div>
    <el-select
      v-model="barr_id"
      placeholder="Filtrar por barrio"
      clearable
      filterable
      @change="handleChangeBarrio"
    >
      <el-option
        v-for="item in options"
        :key="item.barr_id"
        :label="item.barr_descripcion"
        :value="item.barr_id"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="aap_tecnologia"
      placeholder="Filtrar por Tecnologia"
      clearable
      filterable
      @change="handleChangeTecnologia"
    >
      <el-option
        v-for="item in tecnologias"
        :key="item.tecn_id"
        :label="item.tecn_descripcion"
        :value="item.tecn_id"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="aap_potencia"
      placeholder="Filtrar por Potencias"
      clearable
      filterable
      @change="handleChangePotencia"
    >
      <el-option
        v-for="item in potencias"
        :key="item.pot_id"
        :label="item.pot_descripcion"
        :value="item.pot_id"
      >
      </el-option>
    </el-select>
    <el-input
      placeholder="Buscar Luminaria"
      v-model="aap_id"
      clearable
      style="width: 200px;"
    >
    </el-input>
    <el-button @click="handleChangeluminaria()"> Buscar </el-button>
    <el-container>
      <GoogleMapLoader
        v-if="dataLoaded"
        :mapConfig="mapConfig"
        :apiKey="apiKey"
      >
        <template slot-scope="{ loader, map, google }">
          <GoogleMapMarker
            v-for="marker in markers"
            :key="marker.aap_id"
            :marker="marker"
            :loader="loader"
            :map="map"
            :google="google"
          />
        </template>
      </GoogleMapLoader>
    </el-container>
    <el-dialog
      title="Datos Luminaria"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <!-- Datos básicos de la luminaria -->
      <el-row>
        <el-col :span="24">
          <div>
            <el-row>
              <el-col :span="12">
                <p>Código: {{ aap.aap_id }}</p>
                <p>Ubicación: {{ aap.aap_direccion }}</p>
                <p>Barrio: {{ aap.barr_descripcion }}</p>
                <p>Tecnología: {{ aap.aap_tecnologia }}</p>
              </el-col>
              <el-col :span="12">
                <p>Potencia: {{ aap.aap_potencia }}</p>
                <p>Latitud: {{ aap.aap_lat }}</p>
                <p>Longitud: {{ aap.aap_lng }}</p>
                <p>Conexión: {{ aap.aaco_descripcion }}</p>
              </el-col>
            </el-row>
            <!-- Más datos básicos según sea necesario -->
          </div>
        </el-col>
      </el-row>
      <!-- Historia de eventos -->
      <div>
        <h3>Historial de Operaciones</h3>
        <el-table :data="aap.aap_evento" style="width: 100%" height="300">
          <el-table-column label="Fecha Recepción">
            <template slot-scope="scope">
              <span>{{
                scope.row.repo_fecharecepcion | moment('YYYY-MM-DD')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Fecha Solución">
            <template slot-scope="scope">
              <span>{{ scope.row.repo_fechasolucion }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Tipo de Operación">
            <template slot-scope="scope">
              <span>{{ scope.row.reti_descripcion }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Reporte No.">
            <template slot-scope="scope">
              <span>{{ scope.row.repo_consecutivo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Descripción de la Operación">
            <template slot-scope="scope">
              <span>{{ scope.row.repo_descripcion }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Últimas fotos -->
      <div>
        <h3>Últimas fotos</h3>
        <div class="last-photos">
          <img
            v-for="foto in aap.aap_foto"
            :key="foto.id"
            :src="getFotoData(foto.url)"
            alt="Foto"
          />
        </div>
      </div>

      <!-- Botones de acción -->
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="dialogVisible = false"
          >Cerrar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import GoogleMapLoader from '@/components/GoogleMapLoader'
  import GoogleMapMarker from '@/components/GoogleMapMarker'
  import { getGeoreferenciaLuminarias } from '@/api/geo'
  import { apiKey } from '@/api/google'
  import { getBarriosEmpresa } from '@/api/barrio'
  import { getCaracteristica } from '@/api/caracteristica'
  import { getDataLuminaria } from '@/api/luminaria'
  import { getFoto } from '@/api/reporte'

  export default {
    name: 'TravelMap',
    components: {
      GoogleMapLoader,
      GoogleMapMarker
    },
    data() {
      return {
        apiKey: null,
        markers: [],
        dataLoaded: false,
        center: null,
        options: [],
        selectedBarrios: [],
        barr_id: -1,
        aap_tecnologia: '-1',
        tecnologias: [],
        potencias: [],
        aap_potencia: -1,
        aap_id: -1,
        dialogVisible: false,
        luminaria: {},
        historiaEventos: [],
        ultimasFotos: [],
        aap: {
          aap_id: null,
          aap_direccion: null,
          barr_descripcion: null,
          aap_tecnologia: null,
          aap_potencia: null,
          aap_lat: null,
          aap_lng: null,
          aaco_descripcion: null,
          aap_evento: [],
          aap_foto: []
        }
      }
    },
    beforeMount() {
      apiKey()
        .then(response => {
          this.apiKey = response.data
          getBarriosEmpresa().then(response => {
            this.options = response.data
            this.options.unshift({
              barr_id: -1,
              barr_descripcion: 'Filtrar Por Barrios'
            })
            this.setListeners()
            this.getMarkers()
          })
          getCaracteristica(7).then(response => {
            const data = response.data.cara_valores.split(',')
            data.forEach(t => {
              this.tecnologias.push({ tecn_id: t, tecn_descripcion: t })
            })
            this.tecnologias.unshift({
              tecn_id: '-1',
              tecn_descripcion: 'Filtrar por tecnologia'
            })
          })
          getCaracteristica(5)
            .then(response => {
              const data = response.data.cara_valores.split(',')
              data.forEach(p => {
                this.potencias.push({ pot_id: p, pot_descripcion: p })
              })
              this.potencias.unshift({
                pot_id: -1,
                pot_descripcion: 'Filtrar por Potencias'
              })
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
    methods: {
      setListeners() {
        const self = this
        window.addEventListener('show-more-details', function(event) {
          // Acceder al detalle enviado con el evento
          self.aap_id = event.detail.aap_id
          self.showMoreDetails()
        })
      },
      getMarkers() {
        const loading = this.$loading({
          lock: true,
          text: 'Examinado Datos...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        getGeoreferenciaLuminarias(
          this.barr_id,
          this.aap_tecnologia,
          this.aap_potencia,
          this.aap_id
        )
          .then(response => {
            this.markers = response.data
            const marker = this.markers[0]
            this.center = {
              lat: parseFloat(marker.aap_lat),
              lng: parseFloat(marker.aap_lng)
            }
            this.dataLoaded = true
            loading.close()
          })
          .catch(error => {
            console.log(error)
            loading.close()
          })
      },
      handleChangeBarrio() {
        if (!this.barr_id) {
          this.barr_id = -1
        }
        this.dataLoaded = false
        this.getMarkers()
      },
      handleChangeTecnologia() {
        if (!this.aap_tecnologia) {
          this.aap_tecnologia = '-1'
        }
        this.dataLoaded = false
        this.getMarkers()
      },
      handleChangePotencia() {
        if (!this.aap_potencia) {
          this.aap_potencia = -1
        }
        this.dataLoaded = false
        this.getMarkers()
      },
      handleChangeluminaria() {
        if (!this.aap_id) {
          this.aap_id = '-1'
        }
        this.dataLoaded = false
        this.getMarkers()
      },
      showMoreDetails() {
        getDataLuminaria(this.aap_id).then(response => {
          this.aap = response.data
          this.dialogVisible = true
        })
      },
      getFotoData(url) {
        return getFoto(url).then(response => {
          var data = `data:image/jpeg;base64,${response.data.trim()}`
          return `data:image/jpeg;base64,${data}`
        })
      }
    },
    computed: {
      mapConfig() {
        return {
          center: this.center,
          zoom: 10,
          styles: [
            {
              elementType: 'geometry',
              stylers: [
                {
                  color: '#2E2E2E'
                }
              ]
            },
            {
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#000000'
                }
              ]
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#f5f1e6'
                }
              ]
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#c9b2a6'
                }
              ]
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#dcd2be'
                }
              ]
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#ae9e90'
                }
              ]
            },
            {
              featureType: 'landscape.natural',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#93817c'
                }
              ]
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#a5b076'
                }
              ]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#447530'
                }
              ]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f1e6'
                }
              ]
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#fdfcf8'
                }
              ]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f8c967'
                }
              ]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#e9bc62'
                }
              ]
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e98d58'
                }
              ]
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#db8555'
                }
              ]
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#806b63'
                }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#8f7d77'
                }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#ebe3cd'
                }
              ]
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dfd2ae'
                }
              ]
            },
            {
              featureType: 'water',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#b9d3c2'
                }
              ]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#92998d'
                }
              ]
            }
          ]
        }
      }
    }
  }
</script>
<style scoped>
  .last-photos {
    display: flex;
    flex-wrap: wrap;
  }

  .last-photos img {
    width: 100px;
    height: 100px;
    margin: 5px;
  }
</style>
